<template>
  <div>
    <vxe-card size="mini" width="100%">
      <template #title>
        <vxe-select v-model="filters.storer.id" :options="storers" clearable placeholder="placeholder.storer" @change="refresh"/>
        <vxe-input v-model="filters.item.no" clearable placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.lot.no" clearable placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="filters.logicalStore.name" clearable placeholder="business.label.logicalStore" @clear="onLogicalStoreChange([])" @dblclick.native="onLogicalStoreSelect"/>
        <vxe-input v-model="filters.storageRoom.name" clearable placeholder="placeholder.storageRoom" @clear="onStorageRoomChange([])" @dblclick.native="onStorageRoomSelect"/>
        <vxe-input v-model="filters.zone.name" clearable placeholder="placeholder.zone" @clear="onZoneChange([])" @dblclick.native="onZoneSelect"/>
        <vxe-input v-model="filters.location.no" clearable placeholder="placeholder.location" @clear="onLocationChange([])" @dblclick.native="onLocationSelect"/>
        <vxe-input v-model="filters.container.no" clearable placeholder="placeholder.containerNo" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.expConfirm" icon="vxe-icon-upload" status="info" @click="exp"/>
      </template>
      <vxe-table
        ref="table"
        :column-config="{resizable: true}"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow:true}"
        :loading="loading"
        :row-config="{isCurrent: true, isHover: true}"
        align="center"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="storer.name" title="business.label.storer" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="150"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="item.scattered" title="business.label.scattered" width="70"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
        <vxe-column field="pack.innerFactor" title="business.label.innerFactor" width="50"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="100"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="90"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="90"/>
        <vxe-column field="batch.no" title="business.label.batch" width="100"/>
        <vxe-column field="logicalStore.name" title="business.label.logicalStore" width="100"/>
        <vxe-column field="location.no" title="business.label.location" width="120"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="120"/>
        <vxe-column field="zone.name" title="business.label.zone" width="120"/>
        <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:inventoryStates}" field="inventory.inventoryState" title="business.label.inventoryState" width="80"/>
        <vxe-column field="inventory.quantity" title="business.label.quantity" width="80"/>
        <vxe-column field="inventory.availableOutboundQuantity" title="business.label.availableQuantity" width="80"/>
        <vxe-column field="inventory.inboundQuantity" title="business.label.inboundQuantity" width="80"/>
        <vxe-column field="inventory.outboundQuantity" title="business.label.outboundQuantity" width="80"/>
        <vxe-column field="inventory.lockedQuantity" title="business.label.lockedQuantity" width="80"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="lot.producingArea" title="business.label.producingArea" width="100"/>
        <vxe-column :cell-render="{name:'FormatSelect',props:{disabled:true},options:packTypes}" field="inventory.packType" title="business.label.packType" width="60"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="inventory.prioritized" title="business.label.prioritized" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="inventory.remainder" title="business.label.remainder" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="inventory.transitional" title="business.label.transitional" width="70"/>
        <vxe-column field="inventory.replenishedFromQuantity" title="business.label.replenishedFromQuantity" width="80"/>
        <vxe-column field="inventory.replenishedToQuantity" title="business.label.replenishedToQuantity" width="80"/>
        <vxe-column field="inventory.transferredFromQuantity" title="business.label.transferredFromQuantity" width="80"/>
        <vxe-column field="inventory.transferredToQuantity" title="business.label.transferredToQuantity" width="80"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <field-modal ref="logicalStoreModal" :no="'LOGICAL_STORE'" :show-value="false" :title="$t('business.label.logicalStore')" @change="onLogicalStoreChange"/>
    <storage-room-modal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <zone-modal ref="zoneModal" @change="onZoneChange"/>
    <location-modal ref="locationModal" @change="onLocationChange"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { findAll, findEnum } from '@/api/Api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import ZoneModal from '@/views/modal/ZoneModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import { InventoryFactoryView } from '@/api/dto/view/InventoryFactoryView'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Zone } from '@/api/dto/common/Zone'
import { Location } from '@/api/dto/common/Location'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import FieldModal from '@/views/modal/FieldModal.vue'

export default {
  name: 'InventoryQuery',
  components: { FieldModal, StorageRoomModal, ZoneModal, LocationModal },
  data() {
    return {
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      filters: new InventoryFactoryView(),
      data: [],
      storers: [],
      inventoryStates: [],
      packTypes: [],
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  created() {
    Promise.all([
      findAll('storerFactory', { available: true }).then(res => {
        if (res.success) {
          this.storers = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      }),
      findEnum('InventoryState').then(res => {
        if (res.success) {
          this.inventoryStates = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      }),
      findEnum('PackType').then(res => {
        if (res.success) {
          this.packTypes = res.result.map(item => {
            return { label: item.name, value: item.ordinal }
          })
        }
      })
    ]).then(() => this.refresh())
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    onLogicalStoreSelect() {
      this.$refs.logicalStoreModal.open({ available: true })
    },
    onLogicalStoreChange(value) {
      this.filters.logicalStore = new Dictionary(value[0])
      this.refresh()
    },
    onStorageRoomSelect() {
      this.$refs.storageRoomModal.open({ available: true, physical: true })
    },
    onStorageRoomChange(value) {
      this.filters.storageRoom = new StorageRoom(value[0])
      this.refresh()
    },
    onZoneSelect() {
      this.$refs.zoneModal.open({ 'storageRoom.id': this.filters.storageRoom.id })
    },
    onZoneChange(value) {
      this.filters.zone = new Zone(value[0])
      this.refresh()
    },
    onLocationSelect() {
      this.$refs.locationModal.open({ 'storageRoom.id': this.filters.storageRoom.id, 'zone.id': this.filters.zone.id })
    },
    onLocationChange(value) {
      this.filters.location = new Location(value[0])
      this.refresh()
    },
    fetch() {
      this.loading = true
      const args = {
        'storer.id': this.filters.storer.id,
        'item.no': this.filters.item.no,
        'lot.no': this.filters.lot.no,
        'logicalStore.id': this.filters.logicalStore.id,
        'logicalStore.name': this.filters.logicalStore.name,
        'location.id': this.filters.location.id,
        'location.no': this.filters.location.no,
        'zone.id': this.filters.zone.id,
        'zone.name': this.filters.zone.name,
        'storageRoom.id': this.filters.storageRoom.id,
        'storageRoom.name': this.filters.storageRoom.name,
        'container.no': this.filters.container.no
      }
      findAll('inventoryFactory', args, this.page, this.size).then((res) => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.filters = new InventoryFactoryView()
      this.data = []
      this.refresh()
    },
    exp() {
      this.$refs.table.openExport()
    }
  }
}
</script>